<div fxFlex="1 1 100%" fxLayout="row wrap" @fadeInAnimation>
  <ng-content></ng-content>

  <div class="separator" fxFlex="1 1 100%"></div>
</div>
